// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'normalize.css/normalize.css' // A modern alternative to CSS resets
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/index.scss' // global css
import 'font-awesome/css/font-awesome.css'
import './filter'
import './mock' // 数据Mock
import 'babel-polyfill' //IE白屏问题
import format from 'string-format'
import Vue from 'vue'
import ElementUI from 'element-ui';
import {Message} from 'element-ui';
import App from './App'
import store from './store'
import router from './router'
import echarts from 'echarts' //报表插件

format.extend(String.prototype, {})

Vue.use(ElementUI)
Vue.config.productionTip = true//阻止vue在启动时生成生产提示
Vue.prototype.$echarts = echarts

// 全局Loading
Vue.prototype.$loading = function (bool) {
  let loadingBox = document.getElementById('lk-load-box')
  if (Boolean(bool)) {
      if (loadingBox) {
        loadingBox.style.display = 'flex'
      } else {
        let div = document.createElement('div')
        let body = document.querySelector('body')
        div.innerHTML = '<i class="el-icon-loading"></i>'
        div.id = 'lk-load-box'
        div.style.display = 'flex'
        div.style.position = 'fixed'
        div.style.alignItems = 'center'
        div.style.justifyContent = 'center'
        div.style.color = '#409eff'
        div.style.top = 0
        div.style.left = 0
        div.style.bottom = 0
        div.style.right = 0
        div.style.zIndex = 10000000
        div.style.fontSize = '50px'
        div.style.background = 'rgba(0,0,0,0.75)'
        body.appendChild(div)
      }
  } else {
      loadingBox.style.display = 'none'
  }
}

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})

//设置title
document.title = store.state.app.name


// WEBPACK FOOTER //
// ./src/main.js